import { Organization, OrganizationSitesResponse } from '../../types/organization.types'
import { Site } from '../../types/site.types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export interface ListSitesResponse {
  sites: Site[]
}

export const fetchUserOrganization = async (): Promise<Organization> => {
  const response = await apiClient.get<Organization>(ENDPOINTS.organizations.user)
  return response.data
}

export const fetchOrganizationSitesForUser = async (organizationId: string): Promise<OrganizationSitesResponse[]> => {
  const response = await apiClient.get<{ sites: OrganizationSitesResponse[] }>(
    ENDPOINTS.organizations.sites.list(organizationId),
  )
  return response.data.sites
}

export const fetchAllOrganizations = async (): Promise<Organization[]> => {
  const response = await apiClient.get<Organization[]>(ENDPOINTS.organizations.list)
  return response.data
}
